import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { client } from '../lib/sanity';
import { getPetUrlPath } from '../lib/petUtils';

export function SanityPetRedirect() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const redirectToPet = async () => {
      if (!id) {
        navigate('/zwierzeta');
        return;
      }

      try {
        // Pobierz zwierzę po ID z Sanity
        const pet = await client.fetch(
          `*[_type == "pet" && _id == $id && !(_id in path("drafts.**"))][0] {
            slug,
            _id,
            name
          }`,
          { id }
        );

        if (pet) {
          // Użyj funkcji do generowania przyjaznego URL
          navigate(getPetUrlPath(pet), { replace: true });
        } else {
          // Jeśli zwierzę nie istnieje, przekieruj do listy zwierząt
          navigate('/zwierzeta', { replace: true });
        }
      } catch (error) {
        console.error('Error redirecting pet:', error);
        navigate('/zwierzeta', { replace: true });
      } finally {
        setLoading(false);
      }
    };

    redirectToPet();
  }, [id, navigate]);

  if (loading) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-16">
        <p className="text-center text-xl text-accessible-gray-600 dark:text-accessible-gray-300">
          Przekierowywanie...
        </p>
      </div>
    );
  }

  return null;
}
